import type { User } from '../../types/user';
import { axiosInstance } from './axios';
interface LoginResponse {
  access_token: string;
  token_type: string;
}

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const formData = new FormData();
    formData.append('username', email);
    formData.append('password', password);
    
    const response = await axiosInstance.post<LoginResponse>('auth/login', formData);
    return response.data;
  },

  register: async (
    email: string, 
    password: string,
    name: string
  ): Promise<void> => {
    await axiosInstance.post('/auth/register', {
      email,
      password,
      name
    });
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await axiosInstance.get<User>('users/me');
    return response.data;
  },
}; 